import type React from "react"
import {
	createContext,
	startTransition,
	useContext,
	useEffect,
	useMemo,
	useState,
} from "react"

export type openValues = "apex" | "ranger" | "scout"

const VideoContext = createContext<{
	videoSource: openValues
	setVideoSource: React.Dispatch<React.SetStateAction<openValues>>
}>({
	videoSource: "apex",
	setVideoSource: () => "apex",
})

/**
 * access the current header color & theme
 * @param options
 * @param options.videoSource whether the menu should be dark text or light text
 * @returns the current header color & theme
 */
export const useVideoConfig = (options?: { videoSource?: boolean }) => {
	const { videoSource, setVideoSource } = useContext(VideoContext)

	const newVideoSource = options?.videoSource

	useEffect(() => {
		if (typeof newVideoSource === "string")
			startTransition(() => setVideoSource(newVideoSource))
	}, [newVideoSource, setVideoSource])

	return { videoSource, setVideoSource }
}

type Props = {
	children: React.ReactNode
}

export default function VideoProvider({ children }: Props) {
	const [videoSource, setVideoSource] = useState<openValues>("apex")

	const values = useMemo(
		() => ({
			videoSource,
			setVideoSource,
		}),
		[videoSource],
	)

	return (
		<VideoContext.Provider value={values}>{children}</VideoContext.Provider>
	)
}
